export enum FullscreenPopupClosingType {
  CrossIcon = 'crossIcon',
  BarWithBackButton = 'barWithBackButton',
}
